import { SegmentProps } from './props';
import { Segment } from './Segment';

const FooterSegment = (props: SegmentProps) => (
  <Segment {...props} fillColor="brand" />
);

export { FooterSegment };
